import React from 'react';
import { MenuItem, Select, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LEAD_SORT_OPTIONS } from '../utils/leadFilters';

const LeadsSortSelect = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography
        variant="caption"
        color="text.secondary"
      >
        {t('leads.sort.label')}
      </Typography>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="standard"
        disableUnderline
        sx={{
          // Mesmo tamanho do rótulo "Ordenar por" ao lado (o Select nativo é body1).
          typography: 'caption',
          color: 'primary.main',
          '& .MuiSelect-select': {
            py: 0.25,
            pr: '20px !important',
          },
          '& .MuiSelect-icon': {
            color: 'primary.main',
          },
        }}
      >
        {LEAD_SORT_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {t(opt.labelKey)}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};

export default LeadsSortSelect;
